const fastSellProductCurationFormInitialValues = (fastSellProduct) => ({
  curation_status        : fastSellProduct?.curation_status || '',
  curation_reject_label  : fastSellProduct?.curation_reject_label || '',
  curation_reject_reason : fastSellProduct?.curation_reject_reason || ''
})

export default fastSellProductCurationFormInitialValues